export enum IndiaWizardBillingProductTags {
  // Charges (One-time):
  OVERSEAS_DIRECT_INVESTMENT = 'IN---ODI',
  FOREIGN_DIRECT_INVESTMENT = 'IN---FDI',
  INDIA_PVT_LTD_INCORPORATION = 'IN---Pvt-Ltd-Incorporation',
  INDIA_LLP_INCORPORATION = 'IN---LLP-Incorporation',
  // TODO: Update names and add to chargebee:
  INDIA_VIRTUAL_ADDRESS_SERVICE = 'IN---Virtual-Address',
  INDIA_RESIDENT_DIRECTOR_SERVICE = 'IN---Resident-Director',
  INDIA_COMPLIANCE = 'IN---Compliance',
  INDIA_BOOKKEEPING = 'IN---Bookkeeping',
}
